// The Dutch strings: the default locale and every other locale's fallback, so they ship in the
// entry bundle and define the set of message keys (i18n.ts's MessageKey).
import { learnCopy } from "../learn/copy";
import { depthCopy } from "../learn/depthCopy";
import { masteryCopy } from "../learn/masteryCopy";
import { shopCopy } from "../learn/shopCopy";
import { socialCopy } from "../social/copy";
import { uiCopy } from "../uiCopy";

export const nl = {
  "app.meta.name": "proef",
  "home.screen.title": "Scan een fles",
  "home.screen.subtitle":
    "Barcode, e-label QR of een foto van het etiket — proef zoekt de wijn op.",
  "home.action.scan": "Scannen",
  "home.action.search": "Zoek een wijn, producent…",
  "home.recent.title": "Recent gescand",
  "home.recent.empty": "Nog niets gescand. Richt de camera op een fles.",
  "home.about.label": "Over proef",
  "tab.scan.label": "Scannen",
  "tab.search.label": "Zoeken",
  "scan.title.label": "Scan",
  "scan.camera.hint": "Richt op de barcode of het etiket",
  "scan.hint.detect": "Zoeken naar een barcode…",
  "scan.hint.steady": "Houd de camera stil",
  "scan.action.shutter": "Etiket fotograferen",
  "scan.action.pick": "Kies foto",
  "scan.action.manual": "Handmatig invoeren",
  "scan.action.torch": "Lamp",
  "scan.lens.group": "Lens",
  "scan.lens.wide": "Groothoek",
  "scan.lens.ultrawide": "Ultragroothoek",
  "scan.lens.tele": "Tele",
  "scan.lens.numbered": "Camera {n}",
  "scan.zoom.group": "Zoom",
  "scan.zoom.step": "{value}x zoom",
  "scan.zoom.slider": "Zoomniveau",
  "scan.camera.unavailable":
    "Geen camera beschikbaar. Kies een foto van het etiket of voer de wijn handmatig in.",
  "scan.camera.insecure":
    "De camera werkt alleen via https. Kies een foto of open proef via de druif-server.",
  "scan.camera.denied":
    "Camera geweigerd. Sta de camera toe in je browserinstellingen of kies een foto.",
  "scan.found.label": "Barcode gevonden",
  "scan.qr.label": "QR-code gevonden",
  "scan.busy.barcode": "Barcode opzoeken…",
  "scan.busy.label": "Etiket lezen… dit kan tot 20 seconden duren",
  "scan.busy.qr": "E-label opzoeken…",
  "scan.label.busy": "Het herkennen van etiketten is even druk. Probeer het zo meteen opnieuw.",
  "scan.label.failed":
    "Dit etiket kon nu niet worden gelezen. Probeer het opnieuw of voeg de wijn zelf toe.",
  "scan.elabel.failed":
    "Dit e-label is nu niet te lezen. Probeer het opnieuw of voeg de wijn zelf toe.",
  "scan.elabel.unsupported":
    "Dit soort e-label kunnen we nog niet lezen. Voeg de wijn zelf toe of scan een foto van het etiket.",
  "result.screen.title": "Kandidaten",
  "result.state.resolved": "Gevonden",
  "result.field.read": "Gelezen van het etiket",
  "result.read.model": "gelezen door",
  "result.visible.label": "Tekst op het etiket",
  "result.empty.title": "Geen match in de database.",
  "result.none.sub":
    "Pas de gegevens aan en zoek opnieuw, of scan het etiket nog eens met beter licht.",
  "result.action.retry": "Opnieuw scannen",
  "result.action.manual": "Zoek handmatig",
  "result.products.label": "Winkelvermeldingen",
  "result.field.wineries": "Producenten",
  "result.field.barcode": "Barcode",
  "result.error.unknownBarcode": "Deze barcode is niet bekend in de database.",
  "result.qr.page": "E-label pagina",
  "result.qr.open": "Open de pagina van de code",
  "result.elabel.title": "E-label van de producent",
  "result.elabel.source": "Rechtstreeks van de producent, op je telefoon opgehaald.",
  "result.elabel.grapes": "Druiven",
  "result.elabel.abv": "Alcohol",
  "result.elabel.vintage": "Jaargang",
  "result.elabel.serving": "Glas",
  "result.elabel.servingValue": "{ml} ml",
  "result.elabel.ingredients": "Ingrediënten",
  "result.elabel.nutrition": "Voedingswaarde per 100 ml",
  "result.elabel.allergens": "Allergenen",
  "result.elabel.energy": "Energie",
  "result.elabel.fat": "Vet",
  "result.elabel.saturated": "waarvan verzadigd",
  "result.elabel.carbohydrate": "Koolhydraten",
  "result.elabel.sugar": "waarvan suikers",
  "result.elabel.protein": "Eiwitten",
  "result.elabel.salt": "Zout",
  "result.elabel.matching": "Zoeken in de catalogus…",
  "result.elabel.candidates": "Dit kan dezelfde wijn zijn",
  "result.elabel.via": "Via {provider}",
  "result.elabel.volume": "Inhoud",
  "result.elabel.volumeValue": "{ml} ml",
  "result.elabel.fibre": "Vezels",
  "result.elabel.recycling": "Recycling",
  "result.elabel.empty.title": "Nog niets ingevuld",
  "result.elabel.empty.body":
    "De producent heeft dit e-label nog niet ingevuld. Voeg de wijn toe met een foto van het etiket.",
  "confidence.strong.label": "Sterke match",
  "confidence.likely.label": "Waarschijnlijk",
  "confidence.possible.label": "Mogelijk",
  "reason.producer.label": "producent",
  "reason.name.label": "naam",
  "reason.vintage.label": "jaargang",
  "reason.country.label": "land",
  "reason.colour.label": "kleur",
  "reason.appellation.label": "appellatie",
  "reason.grapes.label": "druif",
  "wine.title.label": "Wijn",
  "wine.field.grapes": "Druiven",
  "wine.field.vintages": "Jaargangen",
  "wine.field.rating": "Beoordeling",
  "wine.field.ratings": "beoordelingen",
  "wine.field.products": "In de winkel",
  "wine.products.count": "vermeldingen",
  "wine.field.abv": "Alcohol",
  "wine.field.body": "Body",
  "wine.field.acidity": "Zuren",
  "wine.field.appellation": "Appellatie",
  "wine.field.source": "Bron",
  "wine.label.label": "Etiket",
  "wine.action.again": "Nog een fles scannen",
  "wine.state.notfound": "Wijn niet gevonden.",
  "search.screen.title": "Zoeken",
  "search.field.producer": "Producent",
  "search.field.name": "Wijn",
  "search.field.vintage": "Jaargang",
  "search.field.colour": "Kleur",
  "search.action.submit": "Zoek de wijn",
  "search.field.free": "Of zoek op naam",
  "search.free.placeholder": "bv. Barolo, Sancerre, Loosen…",
  "search.state.results": "Resultaten",
  "search.state.empty": "Niets gevonden.",
  "colour.white.label": "Wit",
  "colour.rose.label": "Rosé",
  "colour.red.label": "Rood",
  "colour.sparkling.label": "Mousserend",
  "colour.fortified.label": "Versterkt",
  "colour.unknown.label": "Onbekend",
  "colour.other.label": "Anders",
  "aroma.cap-hint.label": "Kies tot {n} aromaclusters.",
  "aroma.primary.label": "Primair (druif & gisting)",
  "aroma.secondary.label": "Secundair (na de gisting)",
  "aroma.tertiary.label": "Tertiair (rijping)",
  "aroma.wheel-button.label": "Aromawiel",
  "note.setup.title": "Nieuwe notitie",
  "note.setup.blindTitle": "Blinde proeverij",
  "note.depth.quick": "Snel",
  "note.depth.deep": "Diepgaand",
  "note.depth.quick.hint":
    "Kleur, tot 3 aromaclusters, structuur en oordeel — onder de 60 seconden.",
  "note.depth.deep.hint":
    "Volledige notitie: intensiteit, ontwikkeling, criteria-onderbouwd oordeel.",
  "note.blind.guessHint": "Optioneel: noteer je gok vóór de onthulling.",
  "note.start.label": "Beginnen",
  "note.continue.label": "Verder",
  "note.save.label": "Notitie opslaan",
  "note.saving.label": "Opslaan…",
  "note.section.appearance": "Uiterlijk",
  "note.section.nose": "Neus",
  "note.section.palate": "Mond",
  "note.section.conclusion": "Conclusie",
  "note.section.freeText": "Eigen woorden",
  "note.appearance.colour": "Kleur",
  "note.appearance.clarity": "Helderheid",
  "note.appearance.intensity": "Kleurintensiteit",
  "note.appearance.hue": "Tint",
  "note.appearance.other": "Overig (parels, tranen, bezinksel)",
  "note.clarity.clear": "Helder",
  "note.clarity.hazy": "Troebel",
  "note.intensity.pale": "Bleek",
  "note.intensity.medium": "Gemiddeld",
  "note.intensity.deep": "Diep",
  "note.hue.lemon-green": "Groengeel",
  "note.hue.lemon": "Citroengeel",
  "note.hue.gold": "Goud",
  "note.hue.amber": "Amber",
  "note.hue.brown": "Bruin",
  "note.hue.pink": "Roze",
  "note.hue.salmon": "Zalmroze",
  "note.hue.orange": "Oranje",
  "note.hue.purple": "Paars",
  "note.hue.ruby": "Robijnrood",
  "note.hue.garnet": "Granaatrood",
  "note.hue.tawny": "Tawny",
  "note.nose.condition": "Conditie",
  "note.condition.clean": "Zuiver",
  "note.condition.unclean": "Onzuiver (gebrek)",
  "note.condition.uncleanHint":
    "Een onzuivere neus is een gebrek; het oordeel wordt automatisch ‘gebrekkig’.",
  "note.nose.intensity": "Aromaintensiteit",
  "note.aroma-intensity.light": "Licht",
  "note.aroma-intensity.medium-minus": "Matig-",
  "note.aroma-intensity.medium": "Matig",
  "note.aroma-intensity.medium-plus": "Matig+",
  "note.aroma-intensity.pronounced": "Uitgesproken",
  "note.nose.development": "Ontwikkeling",
  "note.development.youthful": "Jeugdig",
  "note.development.developing": "In ontwikkeling",
  "note.development.fully-developed": "Volledig ontwikkeld",
  "note.development.tired": "Vermoeid",
  "note.nose.descriptors": "Aroma's (neus)",
  "note.aroma.combined": "Aroma's (neus en mond samen)",
  "note.palate.sweetness": "Zoetheid",
  "note.sweetness.dry": "Droog",
  "note.sweetness.off-dry": "Half droog",
  "note.sweetness.medium-dry": "Halfzoet-",
  "note.sweetness.medium-sweet": "Halfzoet",
  "note.sweetness.sweet": "Zoet",
  "note.sweetness.luscious": "Zeer zoet",
  "note.palate.acidity": "Zuren",
  "note.five-step.low": "Laag",
  "note.five-step.medium-minus": "Matig-",
  "note.five-step.medium": "Matig",
  "note.five-step.medium-plus": "Matig+",
  "note.five-step.high": "Hoog",
  "note.palate.tannin": "Tannine",
  "note.palate.body": "Body",
  "note.body.light": "Licht",
  "note.body.medium-minus": "Medium-",
  "note.body.medium": "Medium",
  "note.body.medium-plus": "Medium+",
  "note.body.full": "Vol",
  "note.palate.alcohol": "Alcohol",
  "note.alcohol.low": "Laag",
  "note.alcohol.medium": "Gemiddeld",
  "note.alcohol.high": "Hoog",
  "note.palate.mousse": "Mousse",
  "note.mousse.delicate": "Delicaat",
  "note.mousse.creamy": "Romig",
  "note.mousse.aggressive": "Fel",
  "note.palate.flavourIntensity": "Smaakintensiteit",
  "note.palate.descriptors": "Aroma's (mond)",
  "note.palate.finish": "Afdronk",
  "note.finish.short": "Kort",
  "note.finish.medium-minus": "Matig-",
  "note.finish.medium": "Matig",
  "note.finish.medium-plus": "Matig+",
  "note.finish.long": "Lang",
  "note.conclusion.criteria": "Onderbouwde criteria",
  "note.criterion.balance": "Balans",
  "note.criterion.length": "Lengte",
  "note.criterion.intensity": "Intensiteit",
  "note.criterion.complexity": "Complexiteit",
  "note.conclusion.coach":
    "{n} criteria onderbouwd — dit past bij het oordeel dat je hieronder kiest.",
  "note.conclusion.quality": "Oordeel",
  "note.quality.poor": "Zwak",
  "note.quality.acceptable": "Redelijk",
  "note.quality.good": "Goed",
  "note.quality.very-good": "Zeer goed",
  "note.quality.outstanding": "Uitstekend",
  "note.conclusion.readiness": "Drinkvenster",
  "note.readiness.too-young": "Nog te jong",
  "note.readiness.drink-now-will-improve": "Nu drinkbaar, wordt nog beter",
  "note.readiness.drink-now-not-for-ageing": "Nu drinkbaar, niet voor lagering",
  "note.readiness.too-old": "Over de top",
  "note.free-text.placeholder": "Eigen indrukken, herinneringen, met wie je dit dronk…",
  "tab.cellar.label": "Kelder",
  "tab.taste.label": "Proeven",
  "tab.learn.label": "Ontdekken",
  "tab.samen.label": "Samen",
  "journal.hero.title": "Proef een wijn",
  "journal.hero.sub": "Een gestructureerde notitie, glas in de hand.",
  "journal.blind.label": "Blind proeven",
  "journal.join.label": "Doe mee aan een proeverij",
  "journal.empty.label": "Nog geen notities. Scan een fles om te beginnen.",
  "journal.blind-tag.label": "Blind",
  "blind.title.label": "Blinde proeverij",
  "blind.mystery-bottle.label": "Mysterieuze fles",
  "blind.reveal.label": "Onthullen",
  "blind.your-guess.label": "Jouw gok",
  "blind.correct.label": "Juist!",
  "blind.incorrect.label": "Niet juist",
  "blind.actual-grape.label": "De werkelijke druif",
  "blind.no-candidates.label": "Geen kandidaten voor deze combinatie.",
  "tasting.confirm-delete.label": "Deze notitie verwijderen? Dit kan niet ongedaan worden gemaakt.",
  "tasting.delete.label": "Notitie verwijderen",
  "wine.action.tasteNow": "Proef nu",
  "wine.action.addToCellar": "Voeg toe aan kelder",
  // A method's name, the same in every language: the other locales read this one.
  "tasting.view.karaat": "KARAAT",
  "karaat.kleur.label": "Kleur",
  "karaat.aroma.label": "Aroma",
  "karaat.restsuikers.label": "Restsuikers",
  "karaat.aciditeit.label": "Aciditeit",
  "karaat.alcohol.label": "Alcohol",
  "karaat.tannine.label": "Tannine",
  "karaat.not-applicable.label": "n.v.t.",
  "cellar.title.label": "Kelder",
  "cellar.action.add": "Fles toevoegen",
  "cellar.action.consume": "Dronken",
  "cellar.action.print": "Etiket printen",
  "cellar.action.remove": "Verwijderen uit kelder",
  "cellar.empty.label": "Nog geen flessen in je kelder.",
  "cellar.not-found.label": "Fles niet gevonden.",
  "cellar.filter.all": "Alle",
  "cellar.filter.ready": "Klaar om te drinken",
  "cellar.ready-now.label": "Klaar om te drinken",
  "cellar.ready-from.label": "Vanaf {year}",
  "cellar.field.quantity": "Aantal",
  "cellar.field.location": "Locatie",
  "cellar.field.location.placeholder": "bv. Rek A3, koelkast…",
  "cellar.field.drinkFrom": "Drinken vanaf",
  "cellar.field.label": "Etiket",
  "cellar.label.printed": "Geprint",
  "cellar.label.notPrinted": "Nog niet geprint",
  "cellar.drink-by.label": "Drinken vóór",
  "cellar.added-since.label": "In kelder sinds",
  "cellar.confirm-consume.label": "Deze fles afboeken als gedronken?",
  "cellar.confirm-delete.label": "Deze fles verwijderen uit je kelder?",
  "cellar.add.title": "Fles toevoegen",
  "cellar.add.save": "Opslaan in kelder",
  "cellar.print.title": "Etiket printen",
  "cellar.print.browser": "Printen via browser",
  "cellar.print.niimbot": "Printen via Niimbot (experimenteel)",
  "cellar.print.niimbotWarning":
    "Experimenteel: niet getest op echte Niimbot-hardware. Gebruik ‘Printen via browser’ voor een betrouwbaar resultaat.",
  "cellar.print.connecting": "Verbinden…",
  "cellar.print.printing": "Bezig met printen…",
  "cellar.print.done": "Gereed — etiket verzonden",
  "cellar.print.diagnostic": "Diagnose: toon services van de printer",
  "cellar.print.noServices": "Geen services gevonden.",
  "learn.title.label": "Ontdekken",
  "learn.explore-wheel.label": "Verken het aromawiel",
  "learn.weekly-streak.label": "weken op rij geleerd",
  "learn.collections.label": "Collecties",
  "learn.achievements.label": "Prestaties",
  "flight.host.title": "Proeverij organiseren",
  "flight.host.create": "Proeverij aanmaken",
  "flight.host.badge": "Gastheer",
  "flight.live.wineChanged": "De huidige wijn is veranderd naar {wine}.",
  "flight.live.revealed": "De wijn is onthuld: {wine}.",
  "flight.live.notesUpdated": "{count} notities ingediend voor deze wijn.",
  "flight.live.done": "De proeverij is afgerond.",
  "note.wizard.stepProgress": "Stap {n} van {total}",
  "flight.field.title": "Titel",
  "flight.field.title.placeholder": "bv. Piemonte-avond",
  "flight.field.blind": "Blinde proeverij",
  "flight.field.code": "Code",
  "flight.join.code.hint": "Zes woorden. Plak de hele code of typ woord voor woord.",
  "flight.join.word.label": "Woord {n} van {total}",
  "flight.join.word.suggestions": "Suggesties voor woord {n}",
  "flight.join.word.unknown": "Woord {n}: „{word}” staat niet in de woordenlijst.",
  "flight.field.displayName": "Jouw naam",
  "flight.field.displayName.placeholder": "bv. Kim",
  "flight.wines.label": "Wijnen ({n})",
  "flight.wine-of.label": "Wijn {index} van {total}",
  "flight.notes-submitted.label": "{n} van {total} klaar",
  "flight.you-submitted.label": "Je notitie is opgeslagen. Wacht op de anderen…",
  "flight.action.start": "Beginnen",
  "flight.action.reveal": "Onthullen",
  "flight.action.next": "Volgende wijn",
  "flight.action.finish": "Afronden",
  "flight.action.takeNote": "Notitie maken",
  "flight.lobby.shareHint": "Deel de code of laat iedereen de QR scannen.",
  "flight.lobby.waitingForHost": "Wacht tot de gastheer start…",
  "flight.join.title": "Doe mee",
  "flight.join.action": "Meedoen",
  "flight.join.notFound": "Geen proeverij gevonden met deze code.",
  "flight.join.mode.scan": "Scannen",
  "flight.join.mode.type": "Typ de code",
  "flight.join.scanHint": "Richt je camera op de QR-code van de gastheer",
  "about.field.version": "App-versie",
  "about.field.api": "druif",
  "about.api.checking": "controleren…",
  "about.api.down": "niet bereikbaar",
  "about.field.language": "Taal",
  "about.field.theme": "Thema",
  "about.theme.dark": "Donker",
  "about.theme.light": "Licht",
  "about.action.install": "Installeer op je beginscherm",
  "install.screen.title": "Zet proef op je beginscherm",
  "install.screen.body": "Open proef als app: sneller starten, ook offline, zonder browserbalk.",
  "install.screen.done": "proef staat al op je beginscherm.",
  "install.screen.open": "Open proef",
  "about.install.share": "Deel de installatielink",
  "about.install.copied": "Link gekopieerd",
  "about.field.data": "Wijndata uit druif: X-Wines (CC0), Open Food Facts en open appellatiedata.",
  "common.error.generic": "Er ging iets mis.",
  "error.offline.label": "Geen verbinding met druif.",
  "common.nav.back": "Terug",
  "profile.title.label": "Smaakprofiel",
  "profile.based-on.label": "Gebaseerd op {count} notities die je goed of beter vond",
  "profile.section.clusters": "Favoriete aroma's",
  "profile.section.structure": "Structuurvoorkeur",
  "profile.section.qualityDrivers": "Waarom je een wijn goed vindt",
  "profile.section.blindAccuracy": "Blind proeven per druif",
  "profile.section.recommendations": "Aanbevolen voor jou",
  "profile.empty.title": "Nog geen smaakprofiel",
  "profile.empty.body":
    "Leg een paar proefnotities vast die je goed of beter vindt, dan leren we je smaak kennen.",
  "profile.recommendations.empty":
    "Nog geen aanbevelingen — hoe meer je proeft, hoe beter dit wordt.",
  "profile.cited-count.label": "{count}× in je notities",
  "profile.blind-accuracy.score": "{correct} van {attempts} goed geraden",
  "profile.reason.sharedCluster": "Je waardeert {cluster} vaak hoog",
  "profile.reason.similarStructure": "Zelfde {axis} als je favorieten: {value}",
  "profile.reason.newForYou": "Nieuw voor jou: {grape}",
  "privacy.section.title": "Privacy & je gegevens",
  "privacy.export.title": "Exporteer je gegevens",
  "privacy.export.hint":
    "Download al je proefnotities, je kelder en je leervoortgang als een JSON-bestand.",
  "privacy.export.action": "Exporteren",
  "privacy.export.busy": "Bezig met exporteren…",
  "privacy.delete.title": "Verwijder mijn gegevens",
  "privacy.delete.hint":
    "Verwijdert al je proefnotities, je kelder, je proeverijen en je leervoortgang met oefenhistorie. Dit kan niet ongedaan worden gemaakt.",
  "privacy.delete.action": "Alles verwijderen",
  "privacy.delete.busy": "Bezig met verwijderen…",
  "privacy.delete.confirm":
    "Weet je het zeker? Al je proefnotities, je kelder, je proeverijen en je leervoortgang worden voorgoed verwijderd. Dit kan niet ongedaan worden gemaakt.",
  "common.nav.close": "Sluiten",
  "common.action.retry": "Opnieuw proberen",
  "edge.offline.title": "De proef-dienst is even niet bereikbaar",
  "edge.offline.body":
    "Notities, kelder en voortgang staan bij de proef-dienst, en die geeft nu geen antwoord. Scannen en zoeken in de wijndatabase werken gewoon.",
  "journal.recent.title": "Je proefnotities",
  "journal.empty.title": "Nog geen notities",
  "journal.hero.eyebrow": "Glas in de hand",
  "journal.quick.title": "Samen proeven",
  "scan.mode.label": "Barcode · e-label · etiket",
  "result.read.title": "Van het etiket gelezen",
  "search.title.manual": "Zoek de wijn",
  "search.hint.manual": "Vul in wat je weet — producent of naam is genoeg.",
  "wine.section.terroir": "Terroir",
  "wine.vintages.hint": "Tik op een jaargang voor het klimaat van dat groeiseizoen.",
  "terroir.elevation.label": "Hoogte",
  "terroir.elevation.range": "{min}–{max} m",
  "terroir.soil.label": "Bodem",
  "terroir.soil.texture": "{clay}% klei · {sand}% zand · {silt}% silt",
  "terroir.soil.ph": "pH {ph}",
  "terroir.climate.gdd": "Groeigraaddagen",
  "terroir.climate.frost": "Vorstdagen per jaar",
  "terroir.climate.rain": "Neerslag groeiseizoen",
  "terroir.climate.period": "Klimaatgemiddelden {start}–{end}",
  "terroir.coast.label": "Tot de kust",
  "terroir.river.label": "Tot de rivier",
  "terroir.area.label": "Oppervlakte",
  "terroir.slope.label": "Helling",
  "terroir.aspect.label": "Expositie",
  "terroir.map.legend": "Hoogtebanden",
  "terroir.map.outline": "Begrenzing van {name}",
  "terroir.state.unavailable": "Nog geen terroirdata voor deze appellatie.",

  "terroir.vintage.favorable": "Gunstig groeiseizoen",
  "terroir.vintage.average": "Gemiddeld groeiseizoen",
  "terroir.vintage.challenging": "Lastig groeiseizoen",
  "terroir.vintage.hint":
    "Afgeleid uit het klimaat van {year} in deze appellatie — zonder proefnotities of critici.",
  "terroir.vintage.none": "Geen klimaatarchief voor {year}.",
  "terroir.vintage.loading": "Klimaat ophalen…",
  "wine.field.colour": "Kleur",
  "wine.field.style": "Stijl",
  "cellar.empty.title": "Je kelder is leeg",
  "cellar.ready-count.label": "{n} klaar om te drinken",
  "cellar.add.chosen": "Gekozen fles",
  "cellar.add.change": "Andere fles",
  "cellar.section.window": "Drinkvenster",
  "learn.total-tastings.label": "proefnotities",
  "learn.blind-streak.label": "blinde treffers op rij",
  "learn.collection.missing": "Nog te proeven",
  "learn.collection.complete": "Compleet",
  "learn.profile.hint": "Wat je notities over je smaak zeggen",
  "learn.wheel.hint": "Blader door onze zeventien aromaclusters",
  "learn.achievement.locked": "Nog te behalen",
  "about.section.app": "App",
  "about.section.prefs": "Voorkeuren",
  "about.field.edge": "proef-dienst",
  "about.edge.ok": "verbonden",
  "about.edge.down": "niet verbonden",
  "about.push.unsupported": "Deze browser ondersteunt geen meldingen.",
  "about.push.unconfigured": "Meldingen zijn in deze versie niet ingesteld.",
  "about.push.denied": "Meldingen zijn geblokkeerd. Sta ze toe in de instellingen van je browser.",
  "about.push.ios": "Op iPhone werken meldingen alleen als proef op je beginscherm staat.",
  "about.push.failed": "Het wijzigen van de meldingen is mislukt. Probeer het later opnieuw.",
  "scan.mode.codes": "Barcode · e-label",
  "scan.camera.hint.codes": "Richt op de barcode of de QR-code",
  "scan.camera.unavailable.codes":
    "Geen camera beschikbaar. Zoek de wijn zelf op of voer hem handmatig in.",
  "scan.camera.insecure.codes":
    "De camera werkt alleen via https. Open proef via een beveiligde verbinding of zoek de wijn zelf op.",
  "scan.camera.denied.codes":
    "Camera geweigerd. Sta de camera toe in je browserinstellingen of zoek de wijn zelf op.",
  "autocomplete.producer.list": "Suggesties voor wijnmakers",
  "autocomplete.wine.list": "Suggesties voor wijnen",
  "autocomplete.list.status": "{count} beschikbaar. Blader met de pijltjestoetsen.",
  "autocomplete.add.producer": "“{name}” toevoegen als nieuwe wijnmaker",
  "autocomplete.add.wine": "“{name}” toevoegen als nieuwe wijn",
  "autocomplete.option.unverified": "niet geverifieerd",
  "autocomplete.field.added":
    "“{name}” staat nu op dit toestel. Het wordt ter controle verstuurd zodra je online bent.",
  "barcode.prompt.title": "Nog geen barcode bekend",
  "barcode.prompt.body": "Help anderen {name} te vinden: scan de barcode op je fles.",
  "barcode.prompt.scan": "Barcode scannen",
  "barcode.prompt.later": "Nu niet",
  "barcode.prompt.settingHint": "Je kunt dit verzoek uitzetten bij Over.",
  "barcode.prompt.camera.hint": "Houd de barcode in beeld.",
  "barcode.prompt.manual.label": "Of typ het nummer onder de barcode",
  "barcode.prompt.manual.submit": "Barcode opslaan",
  "barcode.prompt.manual.invalid": "Dat is geen geldig barcodenummer.",
  "barcode.prompt.thanks": "Bedankt. De barcode wordt ter controle verstuurd zodra je online bent.",
  "barcode.prompt.known": "Die barcode staat al bij deze wijn.",
  "barcode.prompt.failed": "De barcode kon niet worden bewaard.",
  "about.contribute.askBarcode": "Vraag me ontbrekende barcodes te scannen",
  "about.contribute.askBarcode.hint":
    "Kies je een wijn zonder bekende barcode, dan bieden we aan die te scannen. Je kunt altijd ‘nu niet’ kiezen.",
  "about.contribute.queue": "{count} bijdragen wachten tot je online bent",
  "about.catalogue.title": "Offline catalogus",
  "about.catalogue.hint":
    "Zet de wijncatalogus op dit toestel: zoeken en scannen werken dan ook zonder internet.",
  "about.catalogue.status": "Status",
  "about.catalogue.status.none": "niet gedownload",
  "about.catalogue.status.ready": "klaar",
  "about.catalogue.status.unusable": "niet te openen",
  "about.catalogue.version": "Versie",
  "about.catalogue.built": "samengesteld op {when}",
  "about.catalogue.size": "Op dit toestel",
  "about.catalogue.checking": "controleren…",
  "about.catalogue.downloading": "Downloaden… {percent}%",
  "about.catalogue.installing": "Opslaan… {percent}%",
  "about.catalogue.removing": "Verwijderen…",
  "about.catalogue.download": "Downloaden ({size})",
  "about.catalogue.update": "Bijwerken ({size})",
  "about.catalogue.check": "Op nieuwe versie controleren",
  "about.catalogue.delete": "Van dit toestel verwijderen",
  "about.catalogue.latest": "Je hebt de nieuwste catalogus.",
  "about.catalogue.updating": "Bijwerken…",
  "about.catalogue.updated": "bijgewerkt op {when}",
  "about.catalogue.auto":
    "Kleine updates worden automatisch op de achtergrond verwerkt. Bij een grote update vragen we eerst.",
  "about.catalogue.deferred.save-data":
    "Een kleine update wacht: databesparing staat aan. Hij volgt zodra dat uit staat, of controleer zelf.",
  "about.catalogue.deferred.metered":
    "Een kleine update wacht op wifi. Hij volgt zodra je niet op mobiele data zit, of controleer zelf.",
  "about.catalogue.available": "Nieuwe versie beschikbaar: {version}.",
  "about.catalogue.edgeoff": "Zet de proef-dienst aan om de catalogus te downloaden.",
  "about.catalogue.error.offline":
    "Geen verbinding met de proef-dienst. Probeer het later opnieuw.",
  "about.catalogue.error.app-too-old":
    "Deze catalogus vraagt een nieuwere versie van proef. Werk de app bij.",
  "about.catalogue.error.no-usable-file": "Er is nu geen bruikbaar catalogusbestand beschikbaar.",
  "about.catalogue.error.download-failed": "Downloaden mislukte. Probeer het later opnieuw.",
  "about.catalogue.error.integrity":
    "De download kwam niet overeen met de controlesom en is weggegooid. Probeer het opnieuw.",
  "about.catalogue.error.storage": "Opslaan op dit toestel lukte niet. Is er genoeg ruimte vrij?",
  "about.catalogue.error.no-space":
    "Niet genoeg vrije ruimte op dit toestel voor de catalogus. Maak ruimte vrij en probeer het opnieuw.",
  "about.catalogue.error.open-failed":
    "De catalogus op dit toestel kan niet worden geopend. Verwijder hem en download opnieuw.",
  "catalogue.prompt.first":
    "Wijnen zoeken en scannen zonder internet? Download de catalogus ({size}).",
  "catalogue.prompt.update": "Er is een nieuwe wijncatalogus ({size}).",
  "catalogue.prompt.download": "Downloaden",
  "catalogue.prompt.update.action": "Bijwerken",
  "catalogue.prompt.later": "Niet nu",
  "catalogue.prompt.space": "{free} vrij op dit toestel",
  "about.section.backends": "Verbindingen",
  "about.backends.hint":
    "Kies met welke diensten deze app praat. Wat uit staat, krijgt geen enkel verzoek.",
  "about.backend.off": "uit",
  "about.backend.use": "{name} gebruiken",
  "about.druif.instance": "Instantie",
  "about.druif.default": "Standaard",
  "about.druif.custom": "Eigen adres",
  "about.druif.url": "Adres van druif",
  "about.druif.save": "Opslaan",
  "about.druif.invalid": "Vul een http- of https-adres in, zonder inlognaam, zoekvraag of #.",
  "about.druif.current": "In gebruik: {url}",
  "about.field.r2": "Cloudflare R2",
  "about.r2.ok": "verbonden",
  "about.r2.down": "niet verbonden",
  "about.r2.unconfigured": "niet ingesteld",
  "about.r2.unknown": "onbekend",
  "about.r2.slice": "laatste export: {when}, {size}",
  "tasting.title.label": "Proefnotitie",
  "tasting.view.label": "Weergave",
  "blind.reveal.hint":
    "Zoek de fles die je blind proefde en koppel hem aan je notitie; je gok wordt dan gescoord.",
  "flight.lobby.participants": "Deelnemers ({n})",
  "flight.results.title": "Uitslag",
  "flight.status.lobby": "Lobby",
  "flight.status.active": "Bezig",
  "flight.status.done": "Afgerond",
  "flight.host.winesHint": "Zoek en voeg de wijnen toe in schenkvolgorde.",
  "common.action.remove": "Verwijderen",
  "common.action.more": "Meer acties",
  "common.pull.hint": "Trek om te verversen",
  "common.pull.release": "Laat los om te verversen",
  "common.pull.busy": "Verversen…",
  "aroma.wheel.hint": "Tik op een cluster om de aroma's te zien.",
  "note.depth.remembered": "Je laatste keuze is onthouden.",
  "wine.field.region": "Regio",
  "about.theme.a11y": "Toegankelijk",
  "about.theme.a11yHint":
    "Toegankelijke versie: hoog contrast (AAA), grotere letters en knoppen, dikkere lijnen, geen animaties. Volgt licht of donker van je toestel.",
  "terroir.where.label": "Waar",
  "terroir.locator.label": "Ligging in {country}",
  "terroir.locator.source": "Landomtrek: Natural Earth (publiek domein)",
  "terroir.map.context": "Ligging in de regio {name}",
  "terroir.region.derived":
    "Omtrek van de regio, samengesteld uit {count} appellaties met een begrenzing.",
  "common.state.cached": "Opgeslagen kopie: het nieuwste kon niet worden opgehaald.",
  ...learnCopy.nl,
  ...shopCopy.nl,
  ...depthCopy.nl,
  ...masteryCopy.nl,
  "addwine.action.label": "Wijn toevoegen",
  "addwine.title.label": "Wijn toevoegen",
  "addwine.intro.label":
    "Controleer wat we hebben gelezen en vul aan wat ontbreekt. Je kunt het straks nog aanpassen.",
  "addwine.offer.hint":
    "Geen enkele wijn in de catalogus past er zeker bij. Voeg de wijn zelf toe.",
  "addwine.field.producer": "Producent",
  "addwine.field.name": "Naam van de wijn",
  "addwine.field.vintage": "Jaargang",
  "addwine.field.vintage.hint": "Leeg laten bij een wijn zonder jaargang.",
  "addwine.field.country": "Land",
  "addwine.field.country.choose": "Kies een land",
  "addwine.field.colour": "Soort",
  "addwine.field.grapes": "Druiven",
  "addwine.field.grapes.hint": "Gescheiden door komma's",
  "addwine.field.abv": "Alcohol (%)",
  "addwine.error.producer": "Vul de producent in.",
  "addwine.error.name": "Vul de naam van de wijn in.",
  "addwine.error.vintage": "Vul een jaar van vier cijfers in, tussen 1800 en 2100.",
  "addwine.error.country": "Kies een land.",
  "addwine.error.colour": "Kies een soort.",
  "addwine.error.abv": "Vul een percentage tussen 0 en 100 in, bijvoorbeeld 13,5.",
  "addwine.error.grapes": "Gebruik hooguit 30 druiven van elk minder dan 100 tekens.",
  "addwine.suggestions.title": "Dit lijkt op",
  "addwine.suggestions.hint":
    "Staat je wijn er al tussen? Open die dan, in plaats van een nieuwe toe te voegen.",
  "addwine.facts.title": "Van het etiket van de producent",
  "addwine.facts.note": "Alleen lezen: dit zijn de gegevens van de producent zelf.",
  "addwine.propose.label": "Stel deze wijn voor aan de catalogus",
  "addwine.propose.hint":
    "Staat uit. Zet je het aan, dan sturen we alleen de gegevens van de wijn mee. Niets over jou, je kelder of je proefnotities.",
  "addwine.propose.hint.elabel":
    "Staat uit. Zet je het aan, dan sturen we alleen de gegevens van de wijn en van het e-label mee. Niets over jou, je kelder of je proefnotities.",
  "addwine.action.save": "Wijn opslaan",
  "addwine.saving.label": "Opslaan…",
  "addwine.error.save": "De wijn kon niet worden opgeslagen. Probeer het opnieuw.",
  "addwine.saved.title": "Wijn opgeslagen",
  "addwine.saved.body": "{name} is nu van jou. Wat wil je ermee?",
  "addwine.action.cellar": "Aan de kelder toevoegen",
  "addwine.cellar.done": "In je kelder",
  "addwine.cellar.error": "Toevoegen aan de kelder lukte niet.",
  "addwine.action.done": "Terug naar scannen",
  "addwine.proposal.sent": "Voorgesteld aan de catalogus. Bedankt!",
  "addwine.proposal.failed": "Het voorstel kon niet worden verstuurd. Je wijn is wel bewaard.",
  "entity.notfound.title": "Niet gevonden",
  "entity.notfound.body": "Deze pagina staat niet in de catalogus, of de link is verouderd.",
  "entity.notfound.action": "Zoeken",
  "entity.manual.title": "Geen cataloguspagina",
  "entity.manual.body":
    "Je voerde deze wijn zelf in, dus er zijn geen catalogusgegevens om te tonen.",
  "entity.list.more": "Meer tonen",
  "entity.list.shown": "{shown} van {total}",
  "entity.link.open": "Open {name}",
  "entity.link.external": "opent in een nieuw tabblad",
  "tasting.wine.nocatalogue": "Geen catalogusgegevens",
  "wine.field.winery": "Producent",
  "wine.field.lwin": "LWIN",
  "wine.field.drinkby": "Drinken voor",
  "wine.section.elabel": "E-label van de producent",
  "wine.section.more": "Meer van {winery}",
  "offers.section.title": "Waar te koop",
  "offers.row.shops": "{retailer} +{count}",
  "offers.unmatched.title": "Verder te koop",
  "offers.summary.range": "{min} tot {max}",
  "offers.summary.line": "Aanbod: {count} · {retailers}",
  "offers.field.abv": "Alcohol",
  "offers.field.sugar": "Restsuiker",
  "offers.field.acid": "Totale zuren",
  "offers.field.aging": "Rijping",
  "offers.field.closure": "Sluiting",
  "offers.field.taste": "Smaak",
  "offers.field.tier": "Kwaliteitsniveau",
  "offers.field.allergens": "Allergenen",
  "offers.field.volume": "Inhoud",
  "offers.unit.gl": "{value} g/l",
  "offers.unit.ml": "{value} ml",
  "offers.link.open": "Bekijk bij {retailer}",
  "winery.title.label": "Producent",
  "winery.field.address": "Adres",
  "winery.field.phone": "Telefoon",
  "winery.field.email": "E-mail",
  "winery.field.website": "Website",
  "winery.field.hours": "Openingstijden",
  "winery.field.wines": "Wijnen",
  "winery.field.parcels": "Percelen",
  "winery.field.cadastre": "Kadastraal perceel",
  "winery.chip.tasting": "Proeflokaal",
  "winery.section.contact": "Contact",
  "winery.section.parcels": "Percelen",
  "winery.section.grapes": "Druiven van de wijnen",
  "winery.section.names": "Wijnen op de eigen site",
  "winery.section.plots": "Wijngaardpercelen",
  "winery.section.wines": "Wijnen",
  "winery.parcels.summary": "{count} percelen · {area} ha",
  "winery.map.parcels": "Percelen van {name}",
  "winery.map.approx": "De exacte ligging van het domein is onbekend; de streek is getoond.",
  "winery.terroir.region": "Gegevens van de streek {name}, niet van het domein zelf.",
  "terroir.section.seasons": "Recente groeiseizoenen",
  "terroir.season.hint": "Graaddagen, vorstdagen en neerslag per groeiseizoen.",
  "terroir.season.year": "Jaar",
  "terroir.season.gdd": "Graaddagen",
  "terroir.season.frost": "Vorst",
  "terroir.season.rain": "Regen",
  "terroir.climate.temp": "Gemiddelde temperatuur",
  "terroir.climate.annual": "Neerslag per jaar",
  "terroir.normal.period": "Klimaatnormaal {period}",
  "terroir.soil.carbon": "Organisch koolstof",
  "terroir.soil.value-gkg": "{value} g/kg",
  "terroir.lithology.label": "Gesteente",
  "terroir.lithology.sc": "Kalksteen en dolomiet",
  "terroir.lithology.ss": "Zandsteen en schalie",
  "terroir.lithology.sm": "Gemengd sedimentgesteente",
  "terroir.lithology.su": "Los sediment",
  "terroir.lithology.mt": "Metamorf gesteente",
  "terroir.lithology.va": "Zuur vulkanisch gesteente",
  "terroir.lithology.vi": "Intermediair vulkanisch gesteente",
  "terroir.lithology.vb": "Basisch vulkanisch gesteente",
  "terroir.lithology.pa": "Zuur plutonisch gesteente",
  "terroir.lithology.pi": "Intermediair plutonisch gesteente",
  "terroir.lithology.pb": "Basisch plutonisch gesteente",
  "terroir.lithology.py": "Pyroclastisch gesteente",
  "terroir.lithology.ev": "Evaporiet",
  "appellation.title.label": "Appellatie",
  "appellation.field.level": "Niveau",
  "appellation.field.parent": "Onderdeel van",
  "appellation.field.website": "Website",
  "appellation.field.wineries": "Producenten",
  "appellation.field.wines": "Wijnen",
  "appellation.field.parcels": "Percelen",
  "appellation.field.vineyard": "Wijngaardoppervlak",
  "appellation.field.production": "Productie",
  "appellation.value.hectares": "{value} ha",
  "appellation.value.hectolitres": "{value} hl",
  "appellation.value.year": "{value} ({year})",
  "appellation.section.grapes": "Druiven",
  "appellation.section.named": "Benoemde wijnen",
  "appellation.section.rules": "Regels van de appellatie",
  "appellation.section.station": "Weerstation",
  "appellation.section.subareas": "Onderdelen",
  "appellation.section.communes": "Gemeenten",
  "appellation.section.wineries": "Producenten",
  "appellation.section.wines": "Wijnen",
  "appellation.grapes.share": "{name} · {share}%",
  "appellation.named.main": "Hoofddruiven",
  "appellation.named.second": "Aanvullend",
  "appellation.rules.varieties": "Toegestane druiven",
  "wine.tier.title": "Wat {tier} hier betekent",
  "wine.tier.rules": "Regels van {name}, volgens het officiële register:",
  "tier.grandcru.generic":
    "Grand Cru betekent 'groot gewas'. In Frankrijk is het een topniveau, maar wat het rangschikt verschilt per streek: één wijngaard (Bourgogne, Elzas), een dorp (Champagne) of een landgoed (Bordeaux). Kijk op het etiket naar wat de appellatie ermee bedoelt.",
  "tier.grandcru.alsace":
    "In de Elzas is Grand Cru geen rang van een producent maar een plek: een benoemde, afgebakende wijngaardhelling, er zijn er 51. De wijn draagt de naam van die wijngaard op het etiket en volgt strengere regels dan de gewone Elzas-appellatie: lagere opbrengsten, rijpere druiven bij de oogst en in de regel alleen de vier edele druiven Riesling, Gewürztraminer, Pinot Gris en Muscat.",
  "tier.grandcru.chablis":
    "Grand Cru is in Chablis het hoogste niveau, boven Premier Cru: een kleine groep benoemde wijngaarden (climats) op één helling boven het stadje. Alleen chardonnay, strengere opbrengsten en de ligging op de beste, zuidwestgerichte kalkhelling maken het verschil.",
  "tier.grandcru.champagne":
    "In Champagne wordt Grand Cru niet aan een wijngaard of huis gegeven maar aan een dorp: de 17 dorpen waarvan de druiven het hoogst werden gewaardeerd. Een champagne met deze naam is gemaakt van druiven uit alleen zulke dorpen.",
  "tier.grandcru.saintemilion":
    "Saint-Émilion Grand Cru is een stap boven gewone Saint-Émilion: de wijn moet rijper geoogst worden, kent lagere opbrengsten en wordt beoordeeld. Het is iets anders dan Grand Cru Classé, een rangschikking van landgoederen die periodiek wordt herzien.",
  "appellation.rules.yield": "Maximale opbrengst",
  "appellation.rules.yieldhl": "{value} hl/ha",
  "appellation.rules.yieldkg": "{value} kg/ha",
  "appellation.rules.density": "Minimale plantdichtheid",
  "appellation.rules.vines": "{value} stokken/ha",
  "appellation.rules.irrigation": "Irrigatie",
  "appellation.irrigation.allowed": "Toegestaan",
  "appellation.irrigation.prohibited": "Verboden",
  "appellation.irrigation.not-specified": "Niet gespecificeerd",
  "appellation.station.temp": "Temperatuur per jaar",
  "appellation.station.rain": "Neerslag per jaar",
  "appellation.station.sun": "Zonuren per jaar",
  "appellation.station.span": "Metingen {first}–{last}",
  "appellation.communes.all": "Alle {count} gemeenten",
  "edgewine.page.title": "Jouw wijn",
  "edgewine.note.title": "Nog niet in de catalogus",
  "edgewine.note.body":
    "Je voegde deze wijn zelf toe. We zoeken {producer} op het web op; vinden we het wijnhuis, dan komen het en zijn wijnen in de catalogus en laten we het je weten.",
  "edgewine.vintage.none": "Zonder jaargang",
  "edgewine.tastings.title": "Je proefnotities van deze wijn",
  "edgewine.cellar.title": "In je kelder",
  "edgewine.cellar.qty": "{n} in voorraad",
  "edgewine.twin.title": "Deze wijn staat in de catalogus",
  "edgewine.twin.body": "Je voerde hem zelf in, maar de catalogus kent hem ook.",
  "edgewine.twin.open": "Open cataloguspagina",
  "notice.winery.added": "Het wijnhuis {name} is toegevoegd aan de catalogus.",
  "notice.winery.open": "Bekijk wijnhuis",
  "notice.winery.close": "Sluiten",
  "scan.label.remaining": "Etiketscans over: {n}",
  "scan.label.limit":
    "Je {limit} etiketscans van de afgelopen 24 uur zijn op. Vanaf {time} kun je weer scannen. Zoek de wijn intussen handmatig.",
  "scan.label.unavailable":
    "Etiketten lezen is nu niet beschikbaar. Zoek de wijn handmatig of scan de barcode.",
  "scan.label.unreadable":
    "Dit etiket was niet te lezen. Probeer een scherpere foto of zoek de wijn handmatig.",
  "terroir.source.open":
    "Open bronnen: Open-Meteo, Copernicus (ERA5, hoogtemodel), SoilGrids, WorldClim, GLiM, OpenStreetMap en open appellatiegrenzen.",
  "winery.map.location": "Ligging van {name}",
  ...socialCopy.nl,
  ...uiCopy.nl,
} as const;
